import { t } from 'i18next';
import { formTemplateStatusEnum, questionTypeEnum } from '../enums';

export const formTemplateStatusLabels: Record<number, string> = {
    [formTemplateStatusEnum.DRAFT]: 'draft',
    [formTemplateStatusEnum.PUBLISHED]: 'published',
    [formTemplateStatusEnum.INACTIVE]: 'inactive',
};

export const questionTypeLabels: Record<number, string> = {
    [questionTypeEnum.MULTIPLE_CHOICE]: 'multipleChoice',
    [questionTypeEnum.SINGLE_CHOICE]: 'singleChoice',
    [questionTypeEnum.TEXT_SHORT]: 'shortAnswer',
    [questionTypeEnum.TEXT_LONG]: 'longAnswer',
};

export const getFormTemplateStatusLabel = (state?: number): string => {
    return state !== undefined && formTemplateStatusLabels[state] ? t(formTemplateStatusLabels[state]) : '';
};

export const getQuestionTypeLabel = (type?: number): string => {
    return type !== undefined && questionTypeLabels[type] ? t(questionTypeLabels[type]) : '';
};
